import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditSmmDomain } from "./FormEditSmmDomain";

export const PanelEditSmmDomain = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
      domain: "",
      price: 0,
      description: "",
      is_active: 1,
      is_sold: 0,
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.SmmDomain.GetOne}/${id}`,
      });

      if (response) {
        setData({
          domain: response.data.domain || "",
            description: response.data.description || "",
            price: response.data.price || 0,
            is_active: response.data.is_active  ? 1 : 0 || 0,
            is_sold: response.data.is_sold || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit SmmDomain <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit SmmDomain: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditSmmDomain data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};
